
import MemberList from '../../components/Member-list'
import WithSidebar from '../../layouts/WithSidebar'
import MemberListHeader from '../../components/Member-list-header'
import './Member.css'
import List from '../../components/List'
import { ajax } from '../../scripts/helper'
import utils from '../../scripts/utils'
import { useSnackbar } from 'notistack'
import { useEffect, useState } from 'react'
import context from '../../scripts/context'


const Members = () => {
    const {enqueueSnackbar} = useSnackbar()
    const [data, setData] = useState([])
    const userInputFields = context.getUserInputFilter()
    const [page, setPage] = useState(userInputFields.page)
    const [totalCounts, setTotalCounts] = useState(userInputFields.totalCounts)
    const [rowsPerPage, setRowsPerPage] = useState(userInputFields.rowsPerPage)
    const columns = [ 
        {name: 'ID'},
        {name: 'Username'},
        {name: 'Name'},
        {name: 'Email'},
        {name: 'Mobile'},
        {name: 'Office'},
        {name: 'Actions'},
    ]

    const makeParams = (inputs)=>{
        let params = ''
        let count = 0
        Object.keys(inputs).forEach( (e) => {
            if(inputs[e].type !== 'select' && inputs[e].value ) {
                if(inputs[e].isDate) {
                    params+= `&${inputs[e].name}=${inputs[e].value.utc(true).toISOString()}`
                    count ++
                }else{
                    params += `&${inputs[e].name}=${inputs[e].value}`
                    count ++
                }
            }
            if(inputs[e].type === 'select' && inputs[e].value) {
                params += `&${inputs[e].name}=${inputs[e].selected}`
                count ++
            }
        })
        // setFilterNumber(count)
        return {params, count}
    }


    const firstParams = makeParams(userInputFields)
    const [params, setParams] = useState(firstParams.params)
    const [filterNumber, setFilterNumber] = useState(firstParams.count)

    const onPageChange = (page, rowsPerPage=10) => {
        context.setUserInputFilter({
            ...context.getUserInputFilter(),
            page:page,
            rowsPerPage: rowsPerPage
        })
        setPage(page)
        setRowsPerPage(rowsPerPage)
        console.log(page, 'page page page')
        getUsers(page)
    }


    const actions = {
        onBlockUser: async(row) => {
            await changeUserStatus(row)
        }
    }

    const changeUserStatus = async (row) => {
        let newStatus = ''
        if(row.status === 'ACTIVE') newStatus = 'INACTIVE'

        if(row.status === 'INACTIVE') newStatus = 'ACTIVE'

        const res = await ajax({
            method: 'PUT',
            url: utils.urls.updateUser(row.id),
            hasToken: true,
            snackbar: enqueueSnackbar,
            data: {
                "status": newStatus
            }
        })

        if(!res) return

        setData(data.map( d => {
            if(d.id === res.data.id) return res.data
            return d
        }))
    }

    const getUsers = async(page) => {
        const res = await ajax({
            method: 'GET',
            url: `${utils.urls.UserList}?size=${context.getUserInputFilter().rowsPerPage}&page=${page}${params}`,
            hasToken: true,
            snackbar: enqueueSnackbar
        })
        if(!res) return

        setData(res.data.content)
        context.setUserInputFilter({
            ...context.getUserInputFilter(),
            totalCounts: res.data.totalElements
        })
        setTotalCounts(res.data.totalElements)
    }

    const onFilter = (inputs) => {
        console.log(inputs,'inputs ee jadid')
        const params = makeParams(inputs).params
        setFilterNumber(makeParams(inputs).count)
        context.setUserInputFilter({
            ...inputs,
            page:0
        })
        setPage(0)
        setParams(params)
    }

    useEffect( () => {
        getUsers(page)
    }, [params])
    return (
        <WithSidebar pageTitle={"Members Management"} breadcrumb={"Dashboard > Members"} listHeaders={<MemberListHeader count={filterNumber} onFilter={(inputs) => onFilter(inputs)} />}>
            <List rows={data} columns={columns} type={'members'} page={page} totalCounts={totalCounts} onPageChange={(page, rowsPerPage) => onPageChange(page, rowsPerPage)} actions={actions} rowsPerPage={rowsPerPage}/>
        </WithSidebar>
    )
}

export default Members